<template>
  <div class="widget white_box">
    <div class="widget_header">
      <h3 class="heading">
        SEO Action Progress
      </h3>
      <a
        v-if="!editing && !preview"
        class="btn primary_btn btn_sm"
        href="/actions"
      >
        See More
      </a>
      <div
        v-if="editing && !preview"
        class="edit_buttons"
      >
        <button
          class="btn btn_sm btn-danger"
          @click="$parent.remove()"
        >
          Delete
        </button>
      </div>
    </div>
    <div
      v-if="!loading"
      class="widget_content"
    >
      <apexchart
        :options="chartOptions"
        :series="series"
        height="400"
        type="radialBar"
      />
      <div class="p_body text-center">
        You have completed {{ completed }} of your assigned {{ assigned }}.
      </div>
    </div>
    <div
      v-else
      class="loading_widget_data"
    >
      <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import axios from 'axios';

export default {
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    removing: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      loading: true,
      series: [0],
      assigned: 0,
      completed: 0,
      options: {
        chart: {
          offsetY: -40
        },
        plotOptions: {
          radialBar: {
            startAngle: -135,
            endAngle: 135,
            track: {
              background: "#e7e7e7",
              strokeWidth: '97%',
              margin: 5, // margin is in pixels
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                color: '#999',
                opacity: 1,
                blur: 2
              }
            },
            dataLabels: {
              name: {
                show: false
              },
              value: {
                offsetY: 8,
                fontSize: '30px'
              }
            }
          }
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            shadeIntensity: 0.4,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 1,
            stops: [0, 50, 53, 91]
          },
        },
        labels: ['Average Results'],
      }
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('dashboard', ['uuid', 'preview', 'chartBaseOptions']),
    chartOptions() {
      return {
        ...this.chartBaseOptions,
        ...this.options
      };
    }
  },
  watch: {
    removing(val) {
      if (val) this.loading = true;
    }
  },
  mounted() {
    axios.post('/ajax/dashboard/get-widget-data', {
      uuid: this.uuid,
      type: 'actionProgress',
    }).then(response => {
      this.series = [response.data.percentage];
      this.assigned = response.data.assigned;
      this.completed = response.data.completed;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }).catch(error => {
      console.log(error);
    });

  },
}
</script>

<style scoped>
.white_box {
  align-self: center;
}

#action_progress {
  height: 360px;
}

.action_progress_chart {
  flex-grow: 1;
}
</style>
